"use strict";
/*
 * Created on 19. 5. 2021
 *
 * Copyright (c) 2021 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var IntegerValidator_1 = require("../../core/model/data-dictionary/validators/IntegerValidator");

var DomainObject_1 = require("../../core/model/DomainObject");

var LockTypeEnum_1 = require("../../product/model/LockTypeEnum");

var UserInfo_1 = require("../../user/model/UserInfo");
/**
 * Distribution exception for replenishment (PROMO-650).
 * @author Radek Beran
 */


var DistributionException =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(DistributionException, _DomainObject_1$Domai);

  /**
   * Creates new distribution exception.
   * @param id internal if of exception
   * @param windowItemId internal id of window item
   * @param promotionId internal id of promotion
   * @param productId internal id of product
   * @param groupOfSitesId internal id of group-of-sites entered for evaluation of resulting sites
   * @param siteIds internal ids of resulting sites for which this exception is valid
   * @param siteExternalIds external ids of resulting sites for which this exception is valid
   * @param distrModelId distribution model for promoted product on resulting sites - internal id
   * of related {@link PromoDistributionModel}
   * @param distrModelDays number of days for certain distribution models,
   * required for "Days to Cover" distribution model
   * @param lockType lock type value for promoted product on resulting sites
   * @param justInTime just-in-time delivery mode
   * @param lastChangeTime date and time of last change of this exception
   * @param lastChangeUser user who last modified this exception
   */
  function DistributionException(id, windowItemId, promotionId, productId, groupOfSitesId, siteIds, siteExternalIds, distrModelId, distrModelDays, lockType, justInTime, lastChangeTime, lastChangeUser) {
    var _this;

    _classCallCheck(this, DistributionException);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DistributionException).call(this));
    _this.id = id;
    _this.windowItemId = windowItemId;
    _this.promotionId = promotionId;
    _this.productId = productId;
    _this.groupOfSitesId = groupOfSitesId;
    _this.siteIds = siteIds;
    _this.siteExternalIds = siteExternalIds;
    _this.distrModelId = distrModelId;
    _this.distrModelDays = distrModelDays;
    _this.lockType = lockType;
    _this.justInTime = justInTime;
    _this.lastChangeTime = lastChangeTime;
    _this.lastChangeUser = lastChangeUser;
    return _this;
  }

  _createClass(DistributionException, [{
    key: "getSiteCnt",
    value: function getSiteCnt() {
      return this.siteIds.size;
    }
  }]);

  return DistributionException;
}(DomainObject_1.DomainObject);

exports.DistributionException = DistributionException;
DistributionException.EMPTY_LIST = immutable_1.List();

DistributionException.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(DistributionException.name);
  return {
    id: builder.id('id'),
    windowItemId: builder.str('windowItemId'),
    promotionId: builder.str('promotionId'),
    productId: builder.str('productId'),
    groupOfSitesId: builder.str('groupOfSitesId'),
    siteIds: builder.listOf(builder.str('siteIds')),
    siteExternalIds: builder.listOf(builder.str('siteExternalIds')),
    distrModelId: builder.opt(builder.lookup('distrModelId', CodebookLookupSequence_1.CodebookLookupSequence.DistributionModel)),
    distrModelDays: builder.opt(builder.num('distrModelDays', new IntegerValidator_1.IntegerValidator())),
    lockType: builder.opt(builder.senum('lockType', LockTypeEnum_1.LockTypeEnum, CodebookLookupSequence_1.CodebookLookupSequence.LockType)),
    justInTime: builder.opt(builder.bool('justInTime')),
    lastChangeTime: builder.date('lastChangeTime', DateParser_1.DateParser.ISO_PATTERN),
    lastChangeUser: builder.obj('lastChangeUser', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    })
  };
}();